<template>
  <v-card flat class="bg-pwt_snow">
    <AvatarRow
      v-if="user"
      :user="user"
      :company="company"
      class="my-5"
    />
    <v-row no-gutters align="center" v-else class="my-5">
      <v-skeleton-loader type="avatar" class="mr-3" color="background" />
      <v-skeleton-loader type="text, text" width="30%" color="background" />
      <v-spacer />
    </v-row>
  </v-card>
</template>

<script setup lang="ts">
import type User from '@/classes/user_classes/user'
import { GettersTypes, type State } from '@/store/store_types'
import { computed } from 'vue'
import { useStore } from 'vuex'
import AvatarRow from './AvatarRow.vue'

const store = useStore<State>()

const user = computed<User | undefined>(() => store.getters[GettersTypes.getCurrentUser])
const company = computed(() => store.state.fleet)
</script>
